import React from 'react';
import AdminUsersProvider from './AdminUsersContext';
import AdminUsers from './AdminUsers';

let Index = () => {
    return (
        <AdminUsersProvider>
            <AdminUsers />
        </AdminUsersProvider>
    )
}

export default Index;